import { useTranslation } from 'react-i18next';
const { DEFAULT_NAMESPACE } = require('services/i18n');

const defaultNamespaces = [DEFAULT_NAMESPACE, 'accessibility', 'link'];

const useI18n = (namespaces: string[] = []) => useTranslation(defaultNamespaces.concat(namespaces));

export default useI18n;
